
    <app-header></app-header>

     <!-- ======= Hero Section ======= -->
  <section id="hero" class="hero_slide">
    <div data-bs-interval="5000" class="" data-bs-ride="carousel">
    <!-- Slide 1 -->
            <div class="container">
			<div class="row">
			<div class="col-lg-6 col-md-6 slider-left-text mt-3 cust-slider-left-text">
			  <h2 class="animate__animated animate__fadeInDown text-alignment-center">IIOT Software <br> Platform</h2>
              <p class="animate__animated animate__fadeInUp width-100 m-0 text-alignment-center">Energyly's Intelligent analytics & Insights helps 
                Industries, Restaurants, BFSI and Retail sector, reduce their power usage. Energyly's Intelligent analytics & Insights helps Industries. </p>
                <div class="flex_center pad-top-25">
              <a (click)="navigatecontact()" class="btn-get-started animate__animated animate__fadeInUp scrollto margin-top-25 cursor_pointer">Contact Us</a>
                </div>
			</div>
			<div class="col-lg-6 col-md-6 text-right">
			  <img src="assets/img/iiot_img.svg" class="slider-img-level slider-img">
			</div>
			</div>
           
			 
            </div>
    </div>
  </section><!-- End Hero -->


  <main id="main">
    <section id="clients" class="clients">
        <div class="container p-0">
            <div class="row client-logo-main">
                <div class="col-lg-2 col-md-4 col-2 d-flex align-items-center justify-content-center cust-padding-7">
                    <img src="../../assets/img/Adani-power-logo.svg" class="img-fluid" alt="">
                </div>

                <div class="col-lg-2 col-md-4 col-2 d-flex align-items-center justify-content-center cust-padding-7">
                    <img src="../../assets/img/Cognitive Technologies.svg" class="img-fluid" alt="">
                </div>

                <div class="col-lg-2 col-md-4 col-2 d-flex align-items-center justify-content-center cust-padding-7">
                    <img src="../../assets/img/Anodyne Technologies.svg" class="img-fluid" alt="">
                </div>

                <div class="col-lg-2 col-md-4 col-2 d-flex align-items-center justify-content-center cust-padding-7">
                    <img src="../../assets/img/Energy Doctor (Tricolite Energy Soln).svg" class="img-fluid" alt="">
                </div>

                <div class="col-lg-2 col-md-4 col-2 d-flex align-items-center justify-content-center cust-padding-7">
                    <img src="../../assets/img/Navi mumbai corporation.svg" class="img-fluid" alt="">
                </div>

                <div class="col-lg-2 col-md-4 col-2 d-flex align-items-center justify-content-center cust-padding-7">
                    <img src="../../assets/img/rech.svg" class="img-fluid" alt="">
                </div>

            </div>

        </div>
    </section>

      <!-- ======= Services Section ======= -->
	  <section id="services" class="services pt-5">
        <div class="container aos-init aos-animate" data-aos="fade-up">
  
          <div class="section-title">
          
            <p>What are the challenges do manufacturer face?</p>
              <!-- <h2>Enthusiastically drive revolutionary opportunities before emerging leadership. Distinctively transform tactical methods of empowerment.</h2> -->
          </div>

        
          
          
           <div class="align-items-center text-center justify-content-center">
               <img src="assets/img/IIOT Software Platform_gif.gif" alt="">
            </div>
  
        </div>
      </section>

         <!-- ======= IIOT SECTION 1 ======= -->
	
	<section id="cta" class="cta space-comman">
	
        <div class="container aos-init aos-animate" data-aos="zoom-in">
         <div class="row">
         <div class="col-lg-6 col-md-6">
         <img src="assets/img/iiot_img1.svg">
         </div>
          <div class="col-lg-6 col-md-6">
          <div class="">
            <h3>What are IIOT Software Platform?</h3>
            <p class="mt-30 text_jus">With Level Monitoring solutions, you can remotely monitor liquid level inside the tank/reservoir in real-time. These solutions allow you to access the fluid level information, temperature, and RH on mobile phones as well as desktops. 

                </p>
  <p class="mt-30">
    Using these solutions, you will be able to manage inventory effectively. The real-time visibility aware you of the days left in existing stock and theft for multiple locations at a time</p>
         
             </div>
          </div>
          </div>
         </div>
      </section>

      <!-- ======= IIOT SECTION 1 ======= -->

       <!-- ======= IIOT SECTION 2 ======= -->

 <section id="Advanced Energy" class="services">
    <div class="container aos-init aos-animate" data-aos="fade-up">
      <div class="row">
          <div class="col-lg-7 col-md-6">
              <div class="section-title Energy-Analytics-title">
      
                <p class="text-left_center">Data Processing & Alerting</p>
                  
              </div>
              <p class="paragraph_text text_jus">Sensors do not always transmit directly relevant information. It is often necessary to process data, apply formulas, create aggregations, calculate averages. The IOT Factory software platform offers an interface for defining the operations that must be performed on the data.<br/><br/>

                Generating alerts based on data received from sensors is essential. These alerts can be viewed in the web application, or sent by email, SMS or mobile push. In real time, or aggregated and transmitted at a defined frequency (every day, every week…).</p>
          </div>
          <div class="col-lg-5 col-md-6" style="padding-top: 20px;">
              <div class="align-items-center text-center justify-content-center">
          <!-- 21:9 aspect ratio -->   
              <img class="embed-responsive-item overviewimg" src="assets/img/iiot_img2.svg"> 

              </div>
          </div>
    </div>
    </div>
  </section>
  <!-- ======= IIOT SECTION 2 ======= -->


 

      <!-- ======= How Rms Works ======= -->
      <section id="How-Rms-Works" class="services gray-container space-comman padding-bottom-50 margin-bottom-0">
        <div class="container aos-init aos-animate" data-aos="fade-up">
  
          <div class="section-title">
            
            <p class="pt-4">Manage Your Devices</p>
            <!-- <h2>With Level Monitoring solutions, you can remotely monitor liquid level inside the tank/reservoir in real-time. These solutions allow you to access the fluid level information, temperature, and RH on mobile phones as well as desktops</h2> -->
          </div>
  
          <div class="row">
         
            <div class="col-lg-4 col-md-6 d-flex align-items-stretch mt-4 aos-init">
              <div class="icon-box height-300 w_100">
                <div class="icon-container pb-3"><img src="assets/img/energy.svg"></div>
                <h4><a href="">Get the real-time data about your devices</a></h4>
                <p class="text_jus">We can connect Samyak's 4g GSM device with water meters' and it will send meter readings to cloud. </p>
              </div>
            </div>
  
              <div class="col-lg-4 col-md-6 d-flex align-items-stretch mt-4 aos-init" data-aos-delay="300">
              <div class="icon-box height-300 w_100">
                  <div class="icon-container pb-3"><img src="assets/img/configuration.svg"></div>
                <h4><a href="">Know the status and act accordingly</a></h4>
                <p class="text_jus">We can connect Samyak's 4g GSM device with water meters' and it will send meter readings to cloud. </p>
              </div>
            </div>
            
  
            <div class="col-lg-4 col-md-6 d-flex align-items-stretch mt-4 aos-init" data-aos-delay="300">
              <div class="icon-box height-300 w_100">
                  <div class="icon-container pb-3"><img src="assets/img/graph.svg"></div>
                <h4><a href="">Set the threshold 
                    of devices</a></h4>
                    <p class="text_jus">Monitor and track water flowing through treatment plants. Also RMS can help in capturing pH, BOD, oxygen and many other  </p>
              </div>
            </div>
            
           
           
          </div>
        </div>
      </section>

      <section id="services" class="services">
        <div class="container aos-init aos-animate" data-aos="fade-up">
    
          <div class="section-title">
          
            <p class="pt-4">IIOT Software Soultion Benefits</p>
              <!-- <h2>Enthusiastically drive revolutionary opportunities before emerging leadership. Distinctively transform 
    tactical methods of empowerment.</h2> -->
          </div>

        
          
           <div class="align-items-center text-center justify-content-center mt-30">
               <img src="assets/img/iiot_software_gif2.gif" class="img-fluid" alt="">
            </div>
    
        </div>
      </section>

        <!-- ======= Testimonials Section ======= -->
        <section id="testimonials" class="testimonials section-bg services padding-bottom-0 mt-30">
            <div class="container aos-init aos-animate" data-aos="fade-up">

                <div class="section-title">

                    <p class="pt-4">Operational Overview & Advance Analytics</p>
                    <!-- <h2>Enthusiastically drive revolutionary opportunities before emerging leadership. Distinctively
                        transform <br>
                        tactical methods of empowerment.</h2> -->
                </div>

                <!-- <div>

                    <p class="paragraph_text_center">With our Biz4Intellia IoT app, utilize the historical data which is ingested by IoT devices. Advance analytics will depict the data into valuable information and help you to analyze the trends.</p>
                    <h2>Enthusiastically drive revolutionary opportunities before emerging leadership. Distinctively
                        transform <br>
                        tactical methods of empowerment.</h2>
                </div> -->

                <div class="best_service">
                    <owl-carousel [options]="SlideOptions1" [carouselClasses]="['owl-theme', 'sliding']">
                        <div class="item" *ngFor="let img of Images1">
                            <div style="align-content: center">
                                <div class="icon-box icon-box2 icon-box3">
                                    <div class="icon-container"><img src="{{img.img}}"></div>
                                    <h4><a href="">{{img.title}}</a></h4>
                                    

                                </div>
                            </div>
                        </div>
                    </owl-carousel>
                </div>
            </div>
        </section>

        <!-- ======= Testimonials2 Industries We Serve Section ======= -->
        <section id="testimonials" class="industries testimonials section-bg services">
            <div class="container aos-init aos-animate" data-aos="fade-up">

                <div class="section-title">

                    <p>Industries We Serve</p>
                    <!-- <h2>Energyly offers smart wireless energy monitoring and controlling solutions for the following
                        industries and <br>connects all the essential devices in their premises to the cloud platform,
                        enabling us to measure and analyze <br> real-time energy data and keeps a record of the
                        electric.</h2> -->
                </div>

                <div class="best_service">
                    <owl-carousel [options]="SlideOptions2" [carouselClasses]="['owl-theme', 'sliding']">
                        <div class="item" *ngFor="let img of Images2">
                            <div class="">
                                <div class="icon-container34">
                                    <p><img class="indus-img" src="{{img.img}}"></p>
                                    <div class="h3">{{img.title}}</div>
                                </div>
                            </div>
                        </div>
                    </owl-carousel>
                </div>

            </div>
        </section>


      <section id="testimonial-area" class="padding-bottom-30">
        <div class="container">
            <div class="col-sm-7 mx-auto">
                <header class="section-header text-center">

                    <h2>What our Customers are Saying</h2>
                </header>
            </div>

            <div id="flex-container" class="testimonials">
                <div id="left-zone">
                    <ul class="list">
                        <!--  <li class="item">
                            <input type="radio" class="circle-click" id="radio_testimonial-1" name="basic_carousel"
                                checked="checked" />
                            <label class="label_testimonial-1 label_user" for="radio_testimonial-1"></label>
                            <div class="content-test content_testimonial-1">

                                <h1> <span><img src="assets/img/comma.svg" class="commam"></span></h1>
                                <p>“Our dedicated patient engagement app and web portal allow you to access
                                    information instantaneously (no tedeous form, long calls, or administrative
                                    hassle) and securely”</p>
                                <div class="testimonial">
                                    <p class="testimonialFrom">Jummal Popis</p>
                                    <p>Founder Circle</p>
                                </div>
                            </div>
                        </li>
                   <li class="item">
                            <input type="radio" class="circle-click" id="radio_testimonial-2"
                                name="basic_carousel" />
                            <label class="label_testimonial-2 label_user" for="radio_testimonial-2"></label>
                            <div class="content-test content_testimonial-2">


                                <h1> <span><img src="assets/img/comma.svg" class="commam"></span></h1>
                                <p>“Our dedicated patient engagement app and web portal allow you to access
                                    information instantaneously (no tedeous form, long calls, or administrative
                                    hassle) and securely”</p>
                                <div class="testimonial">
                                    <p class="testimonialFrom">Jummal Popis</p>
                                    <p>Founder Circle</p>
                                </div>
                            </div>
                        </li>-->
                        <li class="item">
                            <input type="radio" class="circle-click" id="radio_testimonial-3" name="basic_carousel"
                                checked="checked" />
                            <label class="label_testimonial-3 label_user" for="radio_testimonial-3"></label>
                            <div class="content-test content_testimonial-3">

                                <h1> <span><img src="assets/img/comma.svg" class="commam"></span></h1>
                                <p>“Our dedicated patient engagement app and web portal allow you to access
                                    information instantaneously (no tedeous form, long calls, or administrative
                                    hassle) and securely”</p>
                                <div class="testimonial">
                                    <p class="testimonialFrom">Jummal Popis</p>
                                    <p>Founder Circle</p>
                                </div>
                            </div>
                        </li>
                        <!--  <li class="item">
                            <input type="radio" class="circle-click" id="radio_testimonial-4"
                                name="basic_carousel" />
                            <label class="label_testimonial-4 label_user" for="radio_testimonial-4"></label>
                            <div class="content-test content_testimonial-4">

                                <h1> <span><img src="assets/img/comma.svg" class="commam"></span></h1>
                                <p>“Our dedicated patient engagement app and web portal allow you to access
                                    information instantaneously (no tedeous form, long calls, or administrative
                                    hassle) and securely”</p>
                                <div class="testimonial">
                                    <p class="testimonialFrom">Jummal Popis</p>
                                    <p>Founder Circle</p>
                                </div>

                            </div>
                        </li> -->

                    </ul>
                </div>
                <div id="right-zone"></div>
            </div>



        </div>
    </section>


    <!-- ======= Check out latest article ======= -->
    <app-latest-article></app-latest-article>

    <app-footer></app-footer>

  </main>
